import { render, staticRenderFns } from "./OrdersInboundEdit.vue?vue&type=template&id=2fb786db&scoped=true"
import script from "./OrdersInboundEdit.vue?vue&type=script&lang=js"
export * from "./OrdersInboundEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb786db",
  null
  
)

export default component.exports